// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"4fa6a1c6","453":"6aaaf458"}[chunkId] + ".chunk.js";
};